<div class="pt-8">
  <ng-container *ngIf="loading$ | async; else content">
    <div class="w-1/2 flex flex-row">
      <ngx-skeleton-loader count="2"></ngx-skeleton-loader>
    </div>
  </ng-container>
  <ng-template #content>
    <div
      *ngIf="(hideButtons$ | async) === false; else notActionable"
      class="flex flex-col justify-start items-stretch md:flex-row md:justify-center md:items-center"
    >
      <ng-container *ngIf="primaryAddEventType$ | async as primaryAction">
        <button
          mat-flat-button
          color="primary"
          (click)="addEvent(primaryAction)"
          [attr.data-cy]="testIds.PRIMARY_ACTION_BUTTON"
        >
          {{ primaryAction | buttonLabel }}
        </button>
      </ng-container>
      <button
        mat-flat-button
        [matMenuTriggerFor]="otherActions"
        [attr.data-cy]="testIds.OTHER_ACTIONS_DROPDOWN"
      >
        <span class="flex flex-row items-center justify-center space-x-2">
          <span>Other actions</span>
          <mat-icon>expand_more</mat-icon>
        </span>
      </button>
      <mat-menu #otherActions="matMenu">
        <button
          mat-menu-item
          *ngFor="let option of otherEventTypes$ | async"
          [attr.data-cy]="testIds.OTHER_ACTION_PREFIX + option"
          (click)="addEvent(option)"
        >
          {{ option | buttonLabel }}
        </button>
      </mat-menu>
    </div>
    <ng-template #notActionable>
      <em [attr.data-cy]="testIds.CANNOT_TAKE_ACTION_MESSAGE"
        >This job is {{ currentStatus$ | async | workshopJobStatusLabel }}, you
        can not take any further actions on it.</em
      >
    </ng-template>
  </ng-template>
</div>
